export default "__VITE_ASSET__DAo58u6B__"